import fs from 'node:fs'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
export function writeNamespacedFile(srcPath: string, destPath: string, namespace: string): void {
  fs.writeFileSync(
    destPath,
    applyAdminNamespaceToContent(fs.readFileSync(srcPath, 'utf-8'), namespace),
    'utf-8'
  )
}
